import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  bootstrapRoot: {
    padding: 0,
    'label + &': {
      //   marginTop: theme.spacing.unit * 3,
      // marginTop:'10px'    
    },
  },
  bootstrapInput: {
    borderRadius: 4,
    background: 'radial-gradient(10438.51% 17019.45% at 37.86% 37%, rgba(255, 255, 255, 0.7) 0.71%, rgba(255, 255, 255, 0.6) 100%, rgba(255, 255, 255, 0.3) 100%)',
    border: '1px solid #ced4da',
    fontSize: 16,
    padding: '10px 12px',
    marginTop: '10px',
    width: 'calc(100% - 24px)',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
  bootstrapFormLabel: {
    fontSize: 18,
  },

}));